import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col, Pagination, Button, Popconfirm, Collapse } from 'antd';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

import * as pageActions from '../../../../../../data/redux/page_details/actions';
import * as intentActions from '../../../../../../data/redux/intent_details/actions';
import * as nlpActions from '../../../../../../data/redux/nlp_details/actions';
import { getPreemptiveData, getWorkFlowData } from '../../../../../../data/redux/botbuilder_details/actions';

import { APP_PAGES, ROUTE_PATH, PERMISSIONS } from '../../../../../../data/config/constants';
import { showMessage, log } from '../../../../../../data/config/utils';
import { IconEdit, IconDown, IconDelete, IconClose } from '../../../../../../data/assets/icons';

import EditIntentLoader from '../loaders/index';
import ShowMessage from '../../../../../../components/showmessage';
import ErrorBoundary from '../../../../../../components/errorboundary';
import ModalFooter from '../../../../../../components/modalfooter';
import CustomHeader from '../../../../../../components/customheader';
import EditablePageHeader from '../../../../components/editablepageheader';
import AddInputItem from '../../../../../../components/form/addinputItem';
import TextEditor from '../../../../components/texteditor';
import EntityEditor from '../../../../components/entityeditor';
import SelectItem from '../../../../../../components/form/selectitem';
import SwitchItem from '../../../../../../components/form/switchitem';
import ResetParameterForm from '../../../../../../components/form/resetparameterform';
import SelectWorkflowForm from '../../../../../../components/form/selectworkflowform';
import ResetWorkflowsForm from '../../../../../../components/form/resetworkflowsform';
import SelectArrayItem from '../../../../../../components/form/selectarrayitem';

const Panel = Collapse.Panel;

class EditIntent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search_text: "",
            filtered_utterances: props.intent_details.active_intent_data.utterances,
            active_utterance: {},
            current_utterance_page: 1,
            selected_utterance_entity: {
                selected_entity: {},
                utterance_id: null
            },
            new_utterance: null,
        };
    }

    componentWillMount() {
        const { actions } = this.props;
        actions.pageChanged(APP_PAGES.INTENTS, APP_PAGES.BOT_BUILDER);
    }

    componentDidMount() {
        const { match, actions, nlp_details, preemptive_data, workflows } = this.props;
        actions.getIntentData({ intentUniqueId: match.params.intentId });
        if (nlp_details.entities.length === 0) {
            actions.getAllEntities();
        }
        if (workflows.length === 0) {
            actions.getWorkFlowData();
        }
        if (isEmpty(preemptive_data.actions) || isEmpty(preemptive_data.variables) || isEmpty(preemptive_data.messages) || isEmpty(preemptive_data.event_types) || isEmpty(preemptive_data.event_tags)) {
            actions.getPreemptiveData();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { intent_details } = this.props;
        const { search_text } = this.state;

        if (!isEqual(nextProps.intent_details.active_intent_data.utterances, intent_details.active_intent_data.utterances)) {
            const data = [...nextProps.intent_details.active_intent_data.utterances];
            if (search_text.trim().length !== 0) {
                this.setState({
                    filtered_utterances: this.filterUtteranceBySearchText(search_text, data)
                });
            } else {
                this.setState({
                    filtered_utterances: data
                });
            }
        }
    }

    filterUtteranceBySearchText = (text, utterances) => {
        return utterances.filter((utterance) => {
            return (utterance.text && utterance.text !== undefined && utterance.text.toLowerCase().indexOf(text.toLowerCase()) !== -1);
        });
    };

    handleUtteranceSearch = (event) => {
        const search_text = event.target.value;
        const { intent_details } = this.props;

        this.setState({ search_text });
        if (search_text.trim().length !== 0) {
            this.setState({
                filtered_utterances: this.filterUtteranceBySearchText(search_text, intent_details.active_intent_data.utterances)
            });
        } else {
            this.setState({
                filtered_utterances: intent_details.active_intent_data.utterances
            });
        }
    };

    handleSelectedEntityRange = (range, utterance) => {
        log('text range', range);
        log('utterance', utterance);
        if (utterance && utterance.id && range && range.endIndex >= range.startIndex) {
            const entity = utterance.text.substr(range.startIndex, range.endIndex - range.startIndex + 1);
            this.setState({
                selected_utterance_entity: {
                    selected_entity: {
                        startIndex: range.startIndex,
                        endIndex: range.endIndex,
                        entity,
                    },
                    utterance_id: utterance.id
                }
            });
        }
    };

    removeSelectedUtteranceEntity = () => {
        this.setState({
            selected_utterance_entity: {
                selected_entity: {},
                utterance_id: null
            }
        });
    };

    onChangeNewUtterance = e => {
        this.setState({ new_utterance: e.target.value });
    };

    addNewUtterance = () => {
        const { isActionPermitted, intent_details, actions } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.UTTERANCE, PERMISSIONS.ACTION_TYPES.CREATE)) {
            const { new_utterance } = this.state;
            const text = new_utterance.trim();
            if (new_utterance && text.length > 0) {
                const payload = {
                    text,
                    intentUniqueId: intent_details.active_intent_data.intentUniqueId,
                    // intentId: intent_details.active_intent_data.id,
                    intent: intent_details.active_intent_data.intent,
                };
                actions.addNewUtterance(payload, () => this.setState({ new_utterance: null }));
            }
        } else {
            showMessage('warning', 'You have not permission to create new utterance');
        }
    };

    enterKeyDownOnAddNewUtterance = e => {
        if (e.keyCode === 13) {
            this.addNewUtterance();
        }
    };

    updateUtterance = () => {
        const { intent_details, actions } = this.props;
        const payload = {
            utterance: this.state.active_utterance,
            // intentId: intent_details.active_intent_data.id,
            intentUniqueId: intent_details.active_intent_data.intentUniqueId,
        };
        actions.updateUtterance(payload, this.cancelUtteranceEditing);
    };

    deleteUtterance = (utterance) => {
        const { isActionPermitted, intent_details, actions } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.UTTERANCE, PERMISSIONS.ACTION_TYPES.DELETE)) {
            const payload = {
                id: utterance.id,
                intentUniqueId: intent_details.active_intent_data.intentUniqueId,
            };
            actions.deleteUtterance(payload);
        } else {
            showMessage('warning', 'You have not permission to delete any utterance');
        }
    };

    handleUtteranceOverlay = (utterance, callback) => {
        const { isActionPermitted } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.UTTERANCE, PERMISSIONS.ACTION_TYPES.UPDATE)) {
            const { active_utterance } = this.state;
            this.setState({ active_utterance: active_utterance.id !== utterance.id ? utterance : {} }, () => { if (callback) callback(); })
        } else {
            showMessage('warning', 'You have not permission to update any utterance');
        }
    };

    cancelUtteranceEditing = () => {
        this.setState({
            active_utterance: {},
            selected_utterance_entity: {
                selected_entity: {},
                utterance_id: null
            },
        });
    };

    onChangeUtteranceText = e => {
        const { active_utterance } = this.state;
        const text = e.target.value;
        if (!isEmpty(active_utterance)) {
            this.setState({
                active_utterance: { ...active_utterance, text }
            });
        }
    };

    pushEntityInEntityLabels = () => {
        const { active_utterance, selected_utterance_entity } = this.state;
        const entity = selected_utterance_entity.selected_entity;
        if (!isEmpty(active_utterance)) {
            this.setState({
                active_utterance: {
                    ...active_utterance,
                    entityLabels: [...active_utterance.entityLabels, entity]
                }
            });
        }
        this.removeSelectedUtteranceEntity();
    };

    addNewEntity = utterance => {
        const { active_utterance } = this.state;
        if (active_utterance && active_utterance.id !== utterance.id) {
            this.handleUtteranceOverlay(utterance, this.pushEntityInEntityLabels);
        } else {
            this.pushEntityInEntityLabels();
        }
    };

    deleteEntity = index => {
        const { active_utterance } = this.state;
        if (!isEmpty(active_utterance)) {
            this.setState({
                active_utterance: {
                    ...active_utterance,
                    entityLabels: [...active_utterance.entityLabels.slice(0, index), ...active_utterance.entityLabels.slice(index + 1)]
                }
            });
        }
    };

    updateEntityType = (data, index) => {
        const { active_utterance } = this.state;

        if (!isEmpty(active_utterance)) {
            const selected_entity_type = JSON.parse(data);
            log('selected type value', selected_entity_type);
            let updated_entity = active_utterance.entityLabels[index];
            this.setState({
                active_utterance: {
                    ...active_utterance,
                    entityLabels: [...active_utterance.entityLabels.slice(0, index), { ...updated_entity, ...selected_entity_type }, ...active_utterance.entityLabels.slice(index + 1)]
                }
            });
        }
    };

    addResetParameter = () => {
        const { intent_details, actions } = this.props;
        const payload = { key: undefined, value: "" };
        if (intent_details.active_intent_data.resetParameters) {
            let index = intent_details.active_intent_data.resetParameters.length;
            actions.updateIntentState(payload, `active_intent_data.resetParameters.${index}`);
        } else {
            const resetParameters = [payload];
            actions.updateIntentState(resetParameters, `active_intent_data.resetParameters`);
        }
    }

    closeIntent = () => {
        const { actions, history } = this.props;
        history.push(ROUTE_PATH.INTENTS);
        actions.clearActiveIntent();
    };

    updateIntent = () => {
        const { intent_details, actions } = this.props;
        actions.updateIntent(intent_details.active_intent_data, this.closeIntent);
    };

    addContextVariableInResetWorkflows = (data, index) => {
        const { intent_details, actions } = this.props;
        if (intent_details.active_intent_data.resetWorkflows[index].criteria.contextVariables) {
            const cv_index = intent_details.active_intent_data.resetWorkflows[index].criteria.contextVariables.length;
            actions.updateIntentState(data, `active_intent_data.resetWorkflows.${index}.criteria.contextVariables.${cv_index}`);
        } else {
            const contextVariables = [data];
            actions.updateIntentState(contextVariables, `active_intent_data.resetWorkflows.${index}.criteria.contextVariables`)
        }
    }

    addContextVariablesValueExistInResetWorkflows = (data, index) => {
        const { intent_details, actions } = this.props;
        if (intent_details.active_intent_data.resetWorkflows[index].criteria.contextVariablesValueExist) {
            const cv_index = intent_details.active_intent_data.resetWorkflows[index].criteria.contextVariablesValueExist.length;
            actions.updateIntentState(data, `active_intent_data.resetWorkflows.${index}.criteria.contextVariablesValueExist.${cv_index}`);
        } else {
            const contextVariablesValueExist = [data];
            actions.updateIntentState(contextVariablesValueExist, `active_intent_data.resetWorkflows.${index}.criteria.contextVariablesValueExist`)
        }
    }

    addResetWorkflowsItem = () => {
        const { intent_details, actions } = this.props;
        const data = {
            criteria: {},
            message_before: [],
            resetParameters: [],
            resetWorkflow: {}
        };
        if (intent_details.active_intent_data.resetWorkflows) {
            const index = intent_details.active_intent_data.resetWorkflows.length;
            actions.updateIntentState(data, `active_intent_data.resetWorkflows.${index}`)
        } else {
            const resetWorkflows = [data];
            actions.updateIntentState(resetWorkflows, `active_intent_data.resetWorkflows`)
        }
    };

    render() {
        const { active_utterance, current_utterance_page, selected_utterance_entity, new_utterance, filtered_utterances } = this.state;
        const { intent_details, nlp_details, admin_details, actions, preemptive_data, workflows } = this.props;
        const is_empty_filtered_utterance = isEmpty(filtered_utterances);

        if (intent_details.loaders.intent_data_loading && !intent_details.loaders.intent_data_loaded) {
            return (
                <EditIntentLoader />
            );
        } else if (!intent_details.loaders.intent_data_loading && intent_details.loaders.intent_data_loaded) {
            return (
                <div className="ori-full-width ori-b-pad-10">
                    <EditablePageHeader editable title={intent_details.active_intent_data.intent} title_placeholder="Intent Name" onChangeTitle={(e) => actions.updateIntentState(e.target.value, 'active_intent_data.intent')} show_switch checked={intent_details.active_intent_data.status} onChangeSwitch={(bool) => actions.updateIntentState(bool, 'active_intent_data.status')} />
                    <Row>
                        <Col xs={24} sm={{ span: 22, offset: 1 }} md={{ span: 16, offset: 0 }} className="ori-pad-10" >
                            <AddInputItem size="large" placeholder="Add new utterance" value={new_utterance} show_add_btn={new_utterance && new_utterance.trim().length > 0} onChange={this.onChangeNewUtterance} onKeyDown={this.enterKeyDownOnAddNewUtterance} onClickBtn={this.addNewUtterance} />
                            <div className="ori-bg-white ori-lr-pad-10 ori-border-radius-1  ori-box-shadow-light ori-tb-mrgn-10">
                                <CustomHeader title_class="ori-font-bold" title="Training Utterances" search_placeholder="search utterance" onChangeSearch={this.handleUtteranceSearch} show_search />
                                <div className="ori-b-pad-10">
                                    {
                                        filtered_utterances && filtered_utterances.map((utterance, index) => {
                                            const start_page_index = (current_utterance_page - 1) * 10;
                                            const end_page_index = current_utterance_page * 10;
                                            if (start_page_index <= index && index < end_page_index)
                                                return (
                                                    <ErrorBoundary key={utterance.id}>
                                                        <UtteranceCard
                                                            nlpServiceName={admin_details.nlpServiceDetails ? admin_details.nlpServiceDetails.name : " "}
                                                            container_class="ori-tb-mrgn-5"
                                                            utterance={utterance}
                                                            active_utterance={active_utterance}
                                                            entities={nlp_details.entities}
                                                            show_add_entity_btn={selected_utterance_entity.utterance_id === utterance.id}
                                                            add_entity_btn_text={selected_utterance_entity.selected_entity.entity}
                                                            closeEntityBtn={this.removeSelectedUtteranceEntity}
                                                            handleOverlay={() => this.handleUtteranceOverlay(utterance)}
                                                            handleSelectedEntityRange={(range) => this.handleSelectedEntityRange(range, utterance)}
                                                            deleteUtterance={() => this.deleteUtterance(utterance)}
                                                            onChangeUtteranceText={this.onChangeUtteranceText}
                                                            addNewEntity={() => this.addNewEntity(utterance)}
                                                            updateEntityType={this.updateEntityType}
                                                            deleteEntity={this.deleteEntity}
                                                            updateUtterance={this.updateUtterance}
                                                            cancelUtteranceEditing={this.cancelUtteranceEditing} />
                                                    </ErrorBoundary>
                                                );
                                        })
                                    }
                                    {
                                        is_empty_filtered_utterance &&
                                        <div className="ori-lr-pad-10 ori-t-pad-10 ori-text-center">
                                            <span>No utterance avaliable</span>
                                        </div>
                                    }
                                    {
                                        !is_empty_filtered_utterance &&
                                        <div className="ori-tb-pad-10 ori-full-width ori-flex-row ori-flex-jfe">
                                            <Pagination size="small" total={filtered_utterances.length} onChange={(page) => this.setState({ current_utterance_page: page })} />
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="ori-tb-pad-10 ori-l-pad-10 ori-r-pad-15 ori-bg-white ori-box-shadow-light">
                                <ErrorBoundary>
                                    <SelectArrayItem type="object" title="Message Before" title_class="ori-font-bold" select_placeholder="select new message before response" popconfirm_placement="topRight" add_btn_text="add message before" array={intent_details.active_intent_data.message_before} options={preemptive_data.messages} onClickAdd={(value) => actions.updateIntentState(value, `active_intent_data.message_before.${intent_details.active_intent_data.message_before ? intent_details.active_intent_data.message_before.length : 0}`)} onClickDelete={(index) => actions.deleteIntentState(`active_intent_data.message_before.${index}`)} />
                                </ErrorBoundary>
                                <ErrorBoundary>
                                    <SelectArrayItem type="object" title="Message After" title_class="ori-font-bold" select_placeholder="select new message after response" popconfirm_placement="topRight" add_btn_text="add message after" array={intent_details.active_intent_data.message_after} options={preemptive_data.messages} onClickAdd={(value) => actions.updateIntentState(value, `active_intent_data.message_after.${intent_details.active_intent_data.message_after ? intent_details.active_intent_data.message_after.length : 0}`)} onClickDelete={(index) => actions.deleteIntentState(`active_intent_data.message_after.${index}`)} />
                                </ErrorBoundary>
                            </div>
                        </Col>
                        <Col xs={24} sm={{ span: 22, offset: 1 }} md={{ span: 8, offset: 0 }} className="ori-pad-10" >
                            <p className="ori-font-bold ori-font-md" >Properties</p>
                            <ErrorBoundary>
                                <SelectItem allow_clear show_search title="action" placeholder="Select action" options={preemptive_data.actions} value={intent_details.active_intent_data.action} onChange={(value) => actions.updateIntentState(value, 'active_intent_data.action')} />
                            </ErrorBoundary>
                            <ErrorBoundary>
                                <SwitchItem title="NLP Speech" checked={intent_details.active_intent_data.nlpSpeech} onChange={(bool) => actions.updateIntentState(bool, 'active_intent_data.nlpSpeech')} switch_first />
                            </ErrorBoundary>
                            <ErrorBoundary>
                                <SwitchItem title="Reset Context" checked={intent_details.active_intent_data.resetContext} onChange={(bool) => actions.updateIntentState(bool, 'active_intent_data.resetContext')} switch_first />
                            </ErrorBoundary>
                            <Collapse className="ori-collapse-card ori-collapse-card-white ori-collapse-card-shadow-light ori-t-mrgn-20" accordion>
                                <Panel header="Reset Event" key="event">
                                    <ErrorBoundary>
                                        <SelectItem allow_clear show_search title="Event Tag" placeholder="Select event tag" options={preemptive_data.event_tags} value={intent_details.active_intent_data.tag} onChange={(value) => actions.updateIntentState(value, 'active_intent_data.tag')} />
                                    </ErrorBoundary>
                                    <ErrorBoundary>
                                        <SelectItem allow_clear show_search title="Event Type" placeholder="Select event type" options={preemptive_data.event_types} value={intent_details.active_intent_data.tagType} onChange={(value) => actions.updateIntentState(value, 'active_intent_data.tagType')} />
                                    </ErrorBoundary>
                                </Panel>
                                <Panel header="Reset Parameter" key="reset_parameter">
                                    <ResetParameterForm variables={preemptive_data.variables} reset_parameters={intent_details.active_intent_data.resetParameters} onChangeParameterKey={(key, index) => actions.updateIntentState(key, `active_intent_data.resetParameters.${index}.key`)} onChangeParameterValue={(value, index) => actions.updateIntentState(value, `active_intent_data.resetParameters.${index}.value`)} onClickDeleteResetParameterItem={(index) => actions.deleteIntentState(`active_intent_data.resetParameters.${index}`)} onClickAddResetParameter={this.addResetParameter} />
                                </Panel>
                                <Panel header="Reset Workflow" key="reset_workflow">
                                    <SelectWorkflowForm workflow_container="ori-tb-pad-3" node_container="ori-tb-pad-3" workflows={workflows} wid={intent_details.active_intent_data.resetWorkflow && intent_details.active_intent_data.resetWorkflow.wid ? intent_details.active_intent_data.resetWorkflow.wid : undefined} nodeId={intent_details.active_intent_data.resetWorkflow && intent_details.active_intent_data.resetWorkflow.nodeId ? intent_details.active_intent_data.resetWorkflow.nodeId : undefined} onChangeWorkflow={(wid) => actions.updateIntentState(wid, 'active_intent_data.resetWorkflow.wid')} onChangeNode={(nodeId) => actions.updateIntentState(nodeId, 'active_intent_data.resetWorkflow.nodeId')} show_node_visit node_visit={intent_details.active_intent_data.resetWorkflow && intent_details.active_intent_data.resetWorkflow.nodeVisit ? intent_details.active_intent_data.resetWorkflow.nodeVisit : undefined} onChangeNodeVisit={(nodeVisit) => actions.updateIntentState(nodeVisit, 'active_intent_data.resetWorkflow.nodeVisit')} />
                                </Panel>
                                <Panel header="Reset Workflows Properties" key="reset_workflows_properties">
                                    <ResetWorkflowsForm workflow_container="ori-tb-pad-3" node_container="ori-tb-pad-3" reset_workflows={intent_details.active_intent_data.resetWorkflows} workflows={workflows} variables={preemptive_data.variables} actions={preemptive_data.actions} messages={preemptive_data.messages} onChangeWorkflow={(wid, index) => { actions.updateIntentState(wid, `active_intent_data.resetWorkflows.${index}.resetWorkflow.wid`); actions.updateIntentState(undefined, `active_intent_data.resetWorkflows.${index}.resetWorkflow.nodeId`) }} onChangeNode={(nodeId, index) => actions.updateIntentState(nodeId, `active_intent_data.resetWorkflows.${index}.resetWorkflow.nodeId`)} onChangeNodeVisit={(nodeVisit, index) => actions.updateIntentState(nodeVisit, `active_intent_data.resetWorkflows.${index}.resetWorkflow.nodeVisit`)} reset_parameter_title="Reset Parameter" onChangeParameterKey={(key, index1, index2) => actions.updateIntentState(key, `active_intent_data.resetWorkflows.${index1}.resetParameters.${index2}.key`)} onChangeParameterValue={(value, index1, index2) => actions.updateIntentState(value, `active_intent_data.resetWorkflows.${index1}.resetParameters.${index2}.value`)} onClickDeleteResetParameterItem={(index1, index2) => actions.deleteIntentState(`active_intent_data.resetWorkflows.${index1}.resetParameters.${index2}`)} onClickAddResetParameter={(data, index) => actions.updateIntentState(data, `active_intent_data.resetWorkflows.${index}.resetParameters.${intent_details.active_intent_data.resetWorkflows[index].resetParameters.length}`)} onClickDeleteMessageBeforeItem={(index1, index2) => actions.deleteIntentState(`active_intent_data.resetWorkflows.${index1}.message_before.${index2}`)} onClickAddMessageBeforeItem={(data, index) => actions.updateIntentState(data, `active_intent_data.resetWorkflows.${index}.message_before.${intent_details.active_intent_data.resetWorkflows[index].message_before.length}`)} onChangeContextVariableKey={(key, index1, index2) => { actions.updateIntentState(key, `active_intent_data.resetWorkflows.${index1}.criteria.contextVariables.${index2}.key`) }} onChangeContextVariableValue={(value, index1, index2) => actions.updateIntentState(value, `active_intent_data.resetWorkflows.${index1}.criteria.contextVariables.${index2}.value`)} onClickDeleteContextVariable={(index1, index2) => actions.deleteIntentState(`active_intent_data.resetWorkflows.${index1}.criteria.contextVariables.${index2}`)} onClickAddContextVariable={this.addContextVariableInResetWorkflows} onClickAddContextVariablesValueExist={this.addContextVariablesValueExistInResetWorkflows} onClickDeleteContextVariablesValueExist={(index1, index2) => actions.deleteIntentState(`active_intent_data.resetWorkflows.${index1}.criteria.contextVariablesValueExist.${index2}`)} onChangeCurrentWorkflow={(wid, index) => actions.updateIntentState(wid, `active_intent_data.resetWorkflows.${index}.criteria.current_wid`)} onClickAddResetWorkflows={this.addResetWorkflowsItem} onClickDeleteResetWorkflowsItem={(index) => actions.deleteIntentState(`active_intent_data.resetWorkflows.${index}`)} />
                                </Panel>
                            </Collapse>
                        </Col>
                    </Row>
                    <ModalFooter button_ok_text="save" handleOkClick={this.updateIntent} handleCancelClick={this.closeIntent} />
                </div>
            );
        } else if (!intent_details.loaders.intent_data_loading && !intent_details.loaders.intent_data_loaded) {
            return (
                <ShowMessage title="Error" message="unable to load intent data. please check your intenet connection and reload the page." height={150} width={150} error />
            );
        } else {
            return null;
        }
    }
}

const UtteranceCard = (props) => {
    const { nlpServiceName, utterance, active_utterance, entities, container_class, show_add_entity_btn, add_entity_btn_text, handleOverlay, handleSelectedEntityRange, closeEntityBtn, deleteUtterance, onChangeUtteranceText, addNewEntity, updateEntityType, deleteEntity, updateUtterance, cancelUtteranceEditing } = props;
    const is_show_overlay = active_utterance && active_utterance.id === utterance.id;

    return (
        <div key={utterance.id} className={`ori-relative ${container_class}`}>
            <div className="ori-lr-pad-40 ori-bg-default ori-border-default ori-border-radius-1 ori-min-height-40 ori-t-pad-5">
                <TextEditor text={is_show_overlay ? active_utterance.text : utterance.text} entityArray={is_show_overlay ? active_utterance.entityLabels : utterance.entityLabels} text_area_class="ori-font-md ori-input-none" handleSelectedEntityRange={handleSelectedEntityRange} onChange={(e) => { is_show_overlay && onChangeUtteranceText(e) }} />
                {
                    show_add_entity_btn && add_entity_btn_text && add_entity_btn_text.trim().length > 0 &&
                    <div className="ori-animated ori-zoom-in ori-full-width ori-flex-row ori-flex-jc ori-pad-5">
                        <Button size="small" className="ori-font-xs ori-border-radius-1 ori-lr-pad-10 ori-r-mrgn-15 ori-btn-fill-primary-light" onClick={addNewEntity}>{`add an entity for "${add_entity_btn_text}"`}</Button>
                        <div className="ori-pad-5 ori-flex ori-font-light-hover-default" onClick={closeEntityBtn}>
                            <IconClose size={14} />
                        </div>
                    </div>
                }
            </div>
            <div className={classNames("ori-absolute ori-pad-10 ori-flex ori-align-top-2 ori-align-left-2", { "ori-rotate-180 ori-transition-half": is_show_overlay, "ori-transition-half": !is_show_overlay })}>
                <div className="ori-flex ori-bg-primary ori-border-radius-half ori-font-white">
                    <IconDown size={16} />
                </div>
            </div>
            <Popconfirm placement="topLeft" title="Are you sure delete this Utterance?" okText="Yes" cancelText="No" onConfirm={deleteUtterance} >
                <div className="ori-absolute ori-flex ori-align-top-6 ori-align-right-5 ori-tb-pad-5 ori-font-light-hover-default">
                    <IconDelete size={16} />
                </div>
            </Popconfirm>
            {
                !is_show_overlay &&
                <div className="ori-absolute ori-animated ori-zoom-in ori-flex ori-align-top-7 ori-align-right-25 ori-tb-pad-5 ori-font-light-hover-default" onClick={handleOverlay}>
                    <IconEdit size={14} />
                </div>
            }
            {
                is_show_overlay &&
                <div className="ori-overflow-hidden">
                    <div className="ori-animated ori-translate-down ori-lr-pad-10 ori-t-pad-20 ori-l-border-default ori-b-border-default ori-r-border-default ori-full-width ori-bg-default">
                        {
                            active_utterance && active_utterance.entityLabels && !isEmpty(active_utterance.entityLabels) &&
                            <div className="ori-full-width ori-r-pad-30">
                                <Row className="ori-mobile-hidden ori-lr-pad-5">
                                    <Col xs={24} sm={8} className="ori-lr-pad-5">
                                        <p className="ori-font-xs ">TYPE</p>
                                    </Col>
                                    <Col xs={24} sm={16} className=" ori-lr-pad-5" >
                                        <p className="ori-font-xs ">ENTITY</p>
                                    </Col>
                                </Row>
                                {
                                    active_utterance.entityLabels.map((entity, index) => {
                                        return (
                                            <EntityEditor key={index} index={index} entities={entities} selected_entity={entity} size="default" nlpServiceName={nlpServiceName} updateEntityType={updateEntityType} deleteEntity={deleteEntity} />
                                        );
                                    })
                                }
                            </div>
                        }
                        {
                            isEmpty(active_utterance.entityLabels) &&
                            <div className="ori-pad-10 ori-text-center ori-font-md">
                                <p>No any entity avaliable for this utterance.</p>
                            </div>
                        }
                        <ModalFooter size="small" button_ok_text="update" handleCancelClick={cancelUtteranceEditing} handleOkClick={updateUtterance} />
                    </div>
                </div>
            }
        </div>
    );
}

function mapStateToProps(state) {
    return {
        admin_details: state.admin_details,
        intent_details: state.intent_details,
        nlp_details: state.nlp_details,
        preemptive_data: state.botbuilder_details.preemptive_data,
        workflows: state.botbuilder_details.workflows
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, pageActions, intentActions, nlpActions, { getPreemptiveData, getWorkFlowData }), dispatch)
    };
}

UtteranceCard.propTypes = {
    nlpServiceName: PropTypes.string,
    utterance: PropTypes.object,
    active_utterance: PropTypes.object,
    entities: PropTypes.array,
    container_class: PropTypes.string,
    handleOverlay: PropTypes.func,
    show_add_entity_btn: PropTypes.bool,
    add_entity_btn_text: PropTypes.string,
    closeEntityBtn: PropTypes.func,
    handleSelectedEntityRange: PropTypes.func,
    deleteUtterance: PropTypes.func,
    onChangeUtteranceText: PropTypes.func,
    addNewEntity: PropTypes.func,
    updateEntityType: PropTypes.func,
    deleteEntity: PropTypes.func,
    updateUtterance: PropTypes.func,
    cancelUtteranceEditing: PropTypes.func,
};

UtteranceCard.defaultProps = {
    show_add_entity_btn: false,
};

EditIntent.propTypes = {
    intent_details: PropTypes.object,
    admin_details: PropTypes.object,
    nlp_details: PropTypes.object,
    preemptive_data: PropTypes.object,
    workflows: PropTypes.array,
    actions: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    isActionPermitted: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(EditIntent);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/intents/editintent/index.js